module.exports = __webpack_public_path__ + "static/img/vertex-tree.3d0b6b6b.png";